export const getStringDate = (dateString) =>
  dateString
    ? new Date(dateString).toLocaleString().split(" ").slice(0, 3).join(" ")
    : " ";
